import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { history } from '../routers/AppRouter';
import Modal from 'react-modal';
import loader from '../../images/loader2.gif';
import { setWaitingState } from '../../actions/css';

const Waiting = () => {
  const dispatch  = useDispatch();
  const { 
    waitingStatus, } = useSelector(state => state.css);

  const closeWaiting = () => dispatch(setWaitingState(undefined));
  return(
    <Modal
    isOpen={waitingStatus}
    onRequestClose={closeWaiting}
    ariaHideApp={false}
    contentLabel="lifecare.com"
    closeTimeoutMS={400}
    className='waiting-modal'>
    <div className='waiting-div'>
      <img src={loader} alt='Life Care' title='lifecarefront.com' />
    </div>
        
    </Modal>
  )
};

export default Waiting;
